import { IntlShape } from "react-intl";

import { DietaryCategory } from "../../__generated__/globalTypes";

export const orderedDietsAndMessages: [
  DietaryCategory,
  (intl: IntlShape) => string
][] = [
  [
    DietaryCategory.VEGAN,
    (intl) =>
      intl.formatMessage({
        id: "components/product-filter/ProductFilterSelect:dietName:VEGAN",
        defaultMessage: "Vegan",
      }),
  ],
  [
    DietaryCategory.VEGETARIAN,
    (intl) =>
      intl.formatMessage({
        id: "components/product-filter/ProductFilterSelect:dietName:VEGETARIAN",
        defaultMessage: "Vegetarian",
      }),
  ],
  [
    DietaryCategory.SEAFOOD,
    (intl) =>
      intl.formatMessage({
        id: "components/product-filter/ProductFilterSelect:dietName:SEAFOOD",
        defaultMessage: "Seafood",
      }),
  ],
  [
    DietaryCategory.POULTRY,
    (intl) =>
      intl.formatMessage({
        id: "components/product-filter/ProductFilterSelect:dietName:POULTRY",
        defaultMessage: "Poultry",
      }),
  ],
  [
    DietaryCategory.PORK,
    (intl) =>
      intl.formatMessage({
        id: "components/product-filter/ProductFilterSelect:dietName:PORK",
        defaultMessage: "Pork",
      }),
  ],
  [
    DietaryCategory.GAME_MEAT,
    (intl) =>
      intl.formatMessage({
        id: "components/product-filter/ProductFilterSelect:dietName:GAME_MEAT",
        defaultMessage: "Game Meat",
      }),
  ],
  [
    DietaryCategory.RUMINANT_MEAT,
    (intl) =>
      intl.formatMessage({
        id: "components/product-filter/ProductFilterSelect:dietName:RUMINANT_MEAT",
        defaultMessage: "Ruminant Meat",
      }),
  ],
  [
    DietaryCategory.UNKNOWN,
    (intl) =>
      intl.formatMessage({
        id: "components/product-filter/ProductFilterSelect:dietName:UNKNOWN",
        defaultMessage: "Unknown",
      }),
  ],
];

export const dietsAndMessagesMap: Map<
  DietaryCategory,
  (intl: IntlShape) => string
> = new Map(orderedDietsAndMessages.map(([diet, message]) => [diet, message]));
